import ContentOverlay from "../components/content_overlay";
import {Link} from "react-router-dom";
import "./abstract.css";

function NewsPage(){
    return (
        <ContentOverlay
        heading={<h3 style={{ textAlign: "center" }}>News</h3> }
        text_content={<div><br/><ol>
            <li>
            
           <p><u><a href="data/news/1.%E2%80%98Red%20alert%E2%80%99%20as%20temperatures%20cross%201.5%20degrees%20for%2016%20months%20straight.pdf">&lsquo;Red alert&rsquo; as temperatures cross 1.5 degrees for 16 months straight.pdf</a></u></p></li></ol>
           
            <ol start="2">
            <li>
            
            
            <p><u><a href="data/news/2.Farmers%20pin%20hopes%20on%20new%20agricultural%20calendar%20to%20weather%20climate%20variabilities.pdf">Farmers pin hopes on new agricultural calendar to weather climate variabilities.pdf</a></u></p></li></ol>
           
            <ol start="3">
            <li>
            
            <p><u><a href="data/news/3.Can%20MGNREGS%20work%20as%20a%20social%20protection%20scheme%20for%20women%20in%20heat-stressed%20areas_.pdf">Can MGNREGS work as a social protection scheme for women in heat-stressed areas_.pdf</a></u></p></li></ol>
           
            <ol start="4">
            <li>
            
            
            <p><u><a href="data/news/4.Changing%20patterns%20in%20precipitation%20and%20temperature%20affect%20Kashmir%E2%80%99s%20ecosystem.pdf">Changing patterns in precipitation and temperature affect Kashmir&rsquo;s ecosystem.pdf</a></u></p></li></ol>
           
            <ol start="5">
            <li>
            
            
            <p><u><a href="data/news/5.Cities%20taking%20longer%20to%20shed%20heat%20despite%20surrounding%20greenery_%20Study.pdf">Cities taking longer to shed heat despite surrounding greenery_ Study.pdf</a></u></p></li></ol>
           
            <ol start="6">
            <li>
            
            
            <p><u><a href="data/news/6.Climate%20change%20impact%20on%20agriculture%20leads%20to%201.5%20per%20cent%20loss%20in%20India%E2%80%99s%20GDP.pdf">Climate change impact on agriculture leads to 1.5 per cent loss in India&rsquo;s GDP.pdf</a></u></p></li></ol>
           
            <ol start="7">
            <li>
            
            <p><u><a href="data/news/7.Rising%20heat%20can%20put%204.5%25%20of%20India%E2%80%99s%20GDP%20at%20risk%20by%202030.%20What%20does%20it%20mean%20for%20trade%20and%20logistics.pdf">Rising heat can put 4.5% of India&rsquo;s GDP at risk by 2030. What does it mean for trade and logistics.pdf</a></u></p></li></ol>
           
            <ol start="8">
            <li>
            
            <p><u><a href="data/news/8.With%20rising%20temperatures%20and%20post%20COVID-19%20challenge,%20can%20forest%20management%20show%20a%20way%20for%20India.pdf">With rising temperatures and post COVID-19 challenge, can forest management show a way for India.pdf</a></u></p></li></ol>
           
            <ol start="9">
            <li>
            
            
            <p><u><a href="data/news/9.Elephant%20habitat%20in%20the%20Indian%20subcontinent%20to%20shift%20towards%20the%20Himalayas,%20says%20study.pdf">Elephant habitat in the Indian subcontinent to shift towards the Himalayas, says study.pdf</a></u></p></li></ol>
           
            <ol start="10">
            <li>
            
            
            <p><u><a href="data/news/10.Failure%20to%20cut%20GHG%20emissions%20is%20putting%20species%20conservation%20in%20eastern%20Himalayas%20at%20risk.pdf">1Failure to cut GHG emissions is putting species conservation in eastern Himalayas at risk.pdf</a></u></p></li></ol>
           
            <ol start="11">
            <li>
            
            
            <p><u><a href="data/news/11.Himalayan%20treelines%20might%20be%20climbing%20higher%20in%20response%20to%20climate%20change.pdf">Himalayan treelines might be climbing higher in response to climate change.pdf</a></u></p></li></ol>
           
            <ol start="12">
            <li>
            
            
            <p><u><a href="data/news/12.How%20wineries%20in%20India%20are%20adapting%20to%20warmer%20winters%20and%20erratic%20rain.pdf">How wineries in India are adapting to warmer winters and erratic rain.pdf</a></u></p></li></ol>
           
            <ol start="13">
            <li>
            
            
            <p><u><a href="data/news/13.Kerala%E2%80%99s%20early%20heat%20surge%20signals%20climate%20shift.pdf">Kerala&rsquo;s early heat surge signals climate shift.pdf</a></u></p></li></ol>
           
            <ol start="14">
            <li>
            
            
            <p><u><a href="data/news/14.Protect%20India%E2%80%99s%20forests%20and%20urban%20green%20spaces,%20says%20India%E2%80%99s%20climate%20change%20report.pdf">Protect India&rsquo;s forests and urban green spaces, says India&rsquo;s climate change report.pdf</a></u></p></li></ol>
           
            <ol start="15">
            <li>
            
            
            <p><u><a href="data/news/15.Restricting%20global%20temperature%20rise%20to%201.5%C2%B0C%20could%20help%20India%20lower%20drought,%20river%20flooding,%20biodiversity%20loss%20risk.pdf">Restricting global temperature rise to 1.5&deg;C could help India lower drought, river flooding, biodiversity loss risk.pdf</a></u></p></li></ol>
           
            <ol start="16">
            <li>
            
            
            <p><u><a href="data/news/16.These%20flowers%20are%20likely%20to%20climb%20up%20the%20Himalayas%20as%20temperature%20rises.pdf">These flowers are likely to climb up the Himalayas as temperature rises.pdf</a></u></p></li></ol>
           
            <ol start="17">
            <li>
            
            
            <p><u><a href="data/news/17.Rising%20temperatures%20alter%20insect-crop%20interactions%20and%20impact%20agricultural%20productivity.pdf">Rising temperatures alter insect-crop interactions and impact agricultural productivity.pdf</a></u></p></li></ol>
           
            <ol start="18">
            <li>
            
            
            <p><u><a href="data/news/18.Land%20use%20changes%20are%20driving%20Himalayan%20forest%20bird%20loss.pdf">Land use changes are driving Himalayan forest bird loss.pdf</a></u></p></li></ol>
           
            <ol start="19">
            <li>
            
            
            <p><u><a href="data/news/19.Temperature%20rise%20in%20India%E2%80%99s%20northern%20plainsunlikely%20to%20impact%20wheat%20Centre.pdf">Temperature rise in India&rsquo;s northern plains unlikely to impact wheat Centre.pdf</a></u></p></li></ol>
           
            <ol start="20">
            <li>
            
            
            <p><u><a href="data/news/20.The%20climate%20drivers%20behind%20southwest%20India%E2%80%99s%20intensifying%20heat%20waves.pdf">The climate drivers behind southwest India&rsquo;s intensifying heat waves.pdf</a></u></p></li></ol>
           
            <ol start="21">
            <li>
            
            
            <p><u><a href="data/news/21.Warmer%20winters%20in%20the%20Himalayas%20are%20triggering%20avalanches.pdf">Warmer winters in the Himalayas are triggering avalanches.pdf</a></u></p></li></ol>
           
            <ol start="22">
            <li>
            
            <p><u><a href="data/news/22.What%20are%20urban%20heat%20islands.pdf">What are urban heat islands.pdf</a></u></p></li></ol>
           
            <ol start="23">
            <li>
            
            <p><u><a href="data/news/23.Why%20are%20temperatures%20within%20a%20city's%20neighbourhoods%20different.pdf">Why are temperatures within a city's neighbourhoods different.pdf</a></u></p></li></ol>
           
            <ol start="24">
            <li>
            
            
            <p><u><a href="data/news/24.Global%20Heat%20&amp;%20Cooling%20Forum_%20Why%20urgent%20action%20on%20rising%20temperatures%20can%E2%80%99t%20wait,%20as%20per%20experts%20_%20Fortune%20India.pdf">Global Heat &amp; Cooling Forum_ Why urgent action on rising temperatures can&rsquo;t wait, as per experts _ Fortune India.pdf</a></u></p></li></ol>
           
            <ol start="25">
            <li>
            
            
            <p><u><a href="data/news/25.India%20most%20likely%20undercounting%20heat-related%20deaths_%20Former%20WHO%20chief%20scientist%20Soumya%20Swaminathan.pdf">India most likely undercounting heat-related deaths_ Former WHO chief scientist Soumya Swaminathan.pdf</a></u></p></li></ol>
           
            <ol start="26">
            <li>
            
            
            <p><u><a href="data/news/26.Climate%20change%20is%20now%20a%20real%20and%20pressing%20economic%20threat%20_%20Today%20News.pdf">Climate change is now a real and pressing economic threat _ Today News.pdf</a></u></p></li></ol>
           
            <ol start="27">
            <li>
            
            
            <p><u><a href="data/news/27.World%E2%80%99s%20top%20climate%20scientists%20expect%20global%20heating%20to%20blast%20past%201.5C%20target%20_%20Climate%20crisis%20_%20The%20Guardian.pdf">World&rsquo;s top climate scientists expect global heating to blast past 1.5C target _ Climate crisis _ The Guardian.pdf</a></u></p></li></ol>
           
            <ol start="28">
            <li>
            
            
            <p><u><a href="data/news/28.Climate%20Change%20and%20Temperature%20Rise%20in%20India_%20A%20Growing%20Concern%20%E2%80%93%20Rising%20Kashmir.pdf">Climate Change and Temperature Rise in India_ A Growing Concern &ndash; Rising Kashmir.pdf</a></u></p></li></ol>
            <p><a name="_GoBack"></a> </p>
            <ol start="29">
            <li>
            
            
            <p><u><a href="data/news/29.%20Climate%20change%20responsible%20for%20over%2080%25%20of%20temperature%20rise%20within%20Asia%20last%20month,%20the%20hottest%20Apri.pdf">Climate change responsible for over 80% of temperature rise within Asia last month, the hottest April.pdf</a></u></p></li></ol>
           </div>}
        />

    )
}
export default NewsPage;